import React from "react";
import { ThemeProvider } from "@material-ui/core";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import reducers from "./reducers/";
import { CompanyProvider } from "./Context/CompanyContext";
import { SettingProvider } from "./Context/SettingContext";
import { AppProvider } from "./Context/AppContext";
import { EditProvider } from "./Context/EditContext";
import { ItemProvider } from "./Context/ItemContext";
import { StatsProvider } from "./Context/StatsContext";
import { CurrencyProvider } from "./Context/CurrencyContext";
import { CartProvider } from "./Context/CartContext";
import { ItemSearchProvider } from "./Context/ItemSearchContext";
import { DiscountProvider } from "./Context/DiscountContext";
import { StockProvider } from "./Context/StockContext";
import { StaffCommissionDetailProvider } from "./Context/StaffCommissionDetailsContext";
import { ShiftProvider } from "./Context/ShiftContext";
import { OrderSessionProvider } from "./Context/OrderSessionContext";
import { PermissionsProvider } from "./Context/PermissionsContext";
import { ConfirmationProvider } from "./Context/ConfirmationContext";
import theme from "./theme";

const store = createStore(reducers, compose(applyMiddleware(thunk)));

const AppProviders = ({ children }) => {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <ConfirmationProvider>
        <PermissionsProvider>
        <CompanyProvider>
        <AppProvider>
          <SettingProvider>
            <EditProvider>
              <StockProvider>
              <ItemProvider>
                <StatsProvider>
                  <CurrencyProvider>
                    <DiscountProvider>
                      <OrderSessionProvider>
                      <ItemSearchProvider>
                      <CartProvider>
                        <ShiftProvider>
                          <StaffCommissionDetailProvider>
                            {children}
                          </StaffCommissionDetailProvider>
                        </ShiftProvider>
                      </CartProvider>
                      </ItemSearchProvider>
                      </OrderSessionProvider>
                    </DiscountProvider>
                  </CurrencyProvider>
                </StatsProvider>
              </ItemProvider>
              </StockProvider>
            </EditProvider>
          </SettingProvider>
        </AppProvider>
        </CompanyProvider>
        </PermissionsProvider>
        </ConfirmationProvider>
      </ThemeProvider>
    </Provider>
  );
};

export default AppProviders;
